<template>
  <div class="check-all-group">
    <!-- LE-5345 【5288】测试页面的会员等级概况会员等级条件置灰 -->
    <el-checkbox
      :disabled="['market_member_level_general', 'market_member_level_generalTest'].includes(identifyKey)"
      v-if="isShowAllSelect"
      v-model="checkAll"
      @change="handleCheckAllChange"
    >
      {{ allLabel }}
    </el-checkbox>

    <el-divider v-if="isShowDivider"></el-divider>

    <el-checkbox-group class="check-all-group-item" v-model="innerValue" @change="handleCheckedChange">
      <el-checkbox
        :disabled="['market_member_level_general', 'market_member_level_generalTest'].includes(identifyKey) || item.disabled"
        v-for="item in options"
        :key="item[valueKey]"
        :label="item[valueKey]"
      >
        {{ item[labelKey] }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>

export default {
  name: "CheckAllGroup",
  props: {
    identifyKey: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: "value"
    },
    labelKey: {
      type: String,
      default: "label"
    },
    allLabel: {
      type: String,
      default: "全选"
    },
    isShowAllSelect: {
      type: Boolean,
      default: true
    },
    isShowDivider: {
      type: Boolean,
      default: false
    },
    isCheckAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkAll: false,
      innerValue: [],
      hasAutoSelected: false // 标记是否已经自动全选过
    };
  },
  watch: {
    // 监听 identifyKey 的变化（tab 切换时）
    identifyKey: {
      immediate: true,
      handler(val, oldVal) {
        console.log('[watch] identifyKey 改变', val, 'from', oldVal)

        // 当切换到 market_member_level_general 时自动全选（排除禁用项）
        if (val === 'market_member_level_general' && this.options.length > 0) {
          this.$nextTick(() => {
            const enabledOptions = this.options.filter(item => !item.disabled)
            this.innerValue = enabledOptions.map(item => item[this.valueKey])
            this.checkAll = true
            this.hasAutoSelected = true
            this.$emit("input", this.innerValue)
            this.$emit("change", this.innerValue)
            console.log('[identifyKey] market_member_level_general 切换时自动全选:', this.innerValue)
          })
        }
        // 当从 market_member_level_general 切换到其他标识时，重置标志
        else if (oldVal === 'market_member_level_general' && val !== 'market_member_level_general') {
          this.hasAutoSelected = false
          this.innerValue = this.value ? this.value.slice() : []
          this.updateCheckAllStatus()
        }
      }
    },
    // 监听父组件传入的 value
    value: {
      immediate: true,
      handler(val) {
        // 如果是 market_member_level_general，不接受父组件的更新
        if (this.identifyKey === 'market_member_level_general') {
          return;
        }
        this.innerValue = val ? val.slice() : [];
        this.updateCheckAllStatus();
      }
    },
    // 监听 options（异步加载的情况）
    options: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log('[watch] options 改变', val)

        // 如果是 market_member_level_general，且 options 已加载，且未自动全选过（排除禁用项）
        if (this.identifyKey === 'market_member_level_general' &&
            val && val.length > 0 &&
            !this.hasAutoSelected) {
          this.hasAutoSelected = true
          const enabledOptions = val.filter(item => !item.disabled)
          this.innerValue = enabledOptions.map(item => item[this.valueKey])
          this.checkAll = true
          this.$emit("input", this.innerValue)
          this.$emit("change", this.innerValue)
          console.log('[options] market_member_level_general 首次加载自动全选:', this.innerValue)
          return
        }

        // 正常情况下重新计算全选状态
        if (this.identifyKey !== 'market_member_level_general') {
          this.updateCheckAllStatus()
        }
      }
    },
    isCheckAll: {
     immediate: true,
     deep: true,
     handler(val) {
      console.log("isCheckAll",val)
      if(val) {
        // 全选时排除禁用项
        const enabledOptions = this.options.filter(item => !item.disabled);
        this.innerValue = enabledOptions.map(item => item[this.valueKey]);
        this.checkAll = true
        this.$emit("input", this.innerValue);
        this.$emit("change", this.innerValue);
        console.log("this.innerValue",this.innerValue.length)
      }
     },
    },
  },
  methods: {
    handleCheckAllChange(val) {
      // 如果没有 options，避免把 innerValue 设成空数组导致误判
      if (!this.options || this.options.length === 0) {
        this.checkAll = false;
        return;
      }
      // 全选时排除禁用项
      const enabledOptions = this.options.filter(o => !o.disabled);
      this.innerValue = val ? enabledOptions.map(o => o[this.valueKey]) : [];
      this.$emit("input", this.innerValue);
      this.$emit("change", this.innerValue);
    },
    handleCheckedChange(val) {
      this.innerValue = val ? val.slice() : [];
      this.updateCheckAllStatus();
      this.$emit("input", this.innerValue);
      this.$emit("change", this.innerValue);
    },
    updateCheckAllStatus() {
      console.log('this.innerValue',this.innerValue)
      // 只计算可用（非禁用）选项
      const enabledOptions = this.options ? this.options.filter(o => !o.disabled) : [];
      const total = enabledOptions.length;
      // 关键修复：当没有可用 options 时不把 checkAll 设为 true
      if (total === 0) {
        this.checkAll = false;
        return;
      }

      // 关键修复：只计算 innerValue 中实际存在于可用 options 中的数量
      const enabledOptionIds = enabledOptions.map(o => o[this.valueKey]);
      const checkedCount = this.innerValue.filter(v => enabledOptionIds.includes(v)).length;

      this.checkAll = checkedCount === total;
    }
  }
};
</script>


<style lang="less" scoped>
  .el-divider {
    margin: 10px 0;
  }
  .check-all-group {
    .check-all-group-item{
      display: flex;
      flex-direction: column;
    }

  }
  .check-all-group-item{
      display: flex !important;
      flex-direction: column !important;
    }

</style>
